import React from 'react';

import { observer } from 'mobx-react';
import { reverse } from 'named-urls';

import { BackgroundInformationSections } from 'components/Entities/EntityDetailsTab/styles';
import type { TabComponentProps } from 'components/Entities/EntityDetailsContent/types';
import AbstractWrapper from 'components/Entities/EntityRelatedTab/components/AbstractWrapper';
import { defaultProps } from 'components/Entities/EntityRelatedTab/components/types';
import Grid from 'components/Grid';
import { ColumnDefinition } from 'components/Grid/types';

import { ProtectorType } from 'core/constants';
import routes from 'core/routes';

import { useStore } from 'utils/hooks/store';

const RISK_COLUMNS = [
  { field: 'risks__id', headerName: 'ID', protectorType: ProtectorType.Number },
  { field: 'risks__name', headerName: 'Risk', protectorType: ProtectorType.ShortText },
  { field: 'risks__owner', headerName: 'Risk owner', protectorType: ProtectorType.User },
] as unknown as ColumnDefinition[];

const ControlRelatedTab: React.FunctionComponent<TabComponentProps> = ({ store, onError }) => {
  const { routing } = useStore();
  const controlUuid = store.details?.uuid;
  if (!controlUuid) {
    return <></>;
  }

  return (
    <BackgroundInformationSections>
      <AbstractWrapper
        headerTitle="Risks"
        gridElement={
          <Grid
            {...defaultProps}
            gridPagination
            pageSize={20}
            disableSavePreferences
            basicColumns={RISK_COLUMNS}
            entity="risks"
            isEntityList
            dataURL={`/api/entities/controls/${controlUuid}/linked-risks/`}
            fieldsURL="/api/entities/risks/fields/"
            customNoRowsText="No risks on the Risk register use this control"
            onError={onError}
            onRowClick={({ row }) => routing.push(reverse(routes.dashboard.risks.details, { entityId: row.uuid }))}
            testId="control-related-risks-grid"
          />
        }
      />
    </BackgroundInformationSections>
  );
};

export default observer(ControlRelatedTab);
